export const enLangauge = {
  GLOBAL_BTN_YES: 'Yes',
  GLOBAL_BTN_NO: 'No',
  USERS_ACTIVITIES: 'Activities',
  USERS_INSIGHTS: 'Insights',

  USERS_TABLE_HEADER_CUSTOMER_NAME: "Customer Name",
  USERS_TABLE_HEADER_LAST_PURCHASE: "Last Purchase ",
  USERS_TABLE_HEADER_EMAIL: "Email ",
  USERS_TABLE_HEADER_COUNTRY: "Country ",
  USERS_TABLE_HEADER_STATUS: "Status ",
  USERS_TABLE_FILTER: "Filter ",
  USERS_TABLE_SHARE: "Share ",
  REVENUE_ACTIVITIE: "Activities",
  REVENUE_TOTAL_REVENUE: "Total Revenue",
  REVENUE_REVENUE_SOURCE: "Revenue Source",
  REVENUE_TOP_AGENT_HEADING: "Top Agents",
  AGENTS_INSIGHTS: "Insights",
  AGENTS_ACTIVITIES: "Activities",
  AGENTS_HEADING: "Agents",
  AGENT_DETAIL_AGENT: " Agent",
  AGENT_DETAIL_AGENT_VIEW_AGENT: "View Agent",
  AGENT_DETAIL_AGENT_SINCE: " Agent Since",
  AGENT_DETAIL_AGENT_ID: " Agent ID",
  AGENT_DETAIL_EDIT_BTN: "Edit Agents",
  AGENT_DETAIL_SUSPEND_BTN: "Suspend Agents",
  AGENT_DETAIL_LAST_ORDER: " Last Order",
  AGENT_DETAIL_ACTIVE: "Active",
  AGENT_DETAIL_IN_ACTIVE: "In-Active",
  AGENT_DETAIL_PHONE_NUM: "Phone Number",
  AGENT_DETAIL_EMAIL_ID: "Email ID",
  AGENT_DETAIL_HOME_ADDRESS: "Home Address",
  AGENT_DETAIL_BILLING_ADDRESS: "Billing Address",
  AGENT_DETAIL_ALL_OFFERS: "All offer",
  AGENT_DETAIL_ACCOMDATION_OFFER: "Accomdation offer",
  AGENT_DETAIL_CAR_RENTALS: " Cars Rental ",
  AGENT_DETAIL_TABLE_HEADER_TITLE:"Item",
  AGENT_DETAIL_TABLE_HEADER_PRODUCT_NAME: "Product Name",
  AGENT_DETAIL_TABLE_HEADER_UNIT_PRICE: " Unit Price",
  AGENT_DETAIL_TABLE_HEADER_DISCOUNT: " Discount",
  AGENT_DETAIL_TABLE_HEADER_TOTAL_ORDER: "    Total Order",
  AGENT_DETAIL_TABLE_HEADER_ACTION: "Action",
  AGENT_DETAIL_TABLE_HEADER_STATUS: "Status",
  AGENT_DETAIL_TABLE_STATUS_ACTIVE: "Active",
  AGENT_DETAIL_TABLE_STATUS_INACTIVE: "In-Active",
  AGENT_BUTTON_UNAPPROVED:'Unappoved',
  AGENT_BUTTON_AGENTS:'Agents',
  // 
  AGENT_DETAIL_FILTER: "Filter",
  AGENT_DETAIL_SHARE: "Share",
  // AGENT ITEMS 
  AGENT_ITEMS_TITLE:'Unappoved Agents',
  // TopAgent filteration 
  TOP_AGENT_FILTERATION_TIME_FRAMED: "Timeframe : All-time",
  TOP_AGENT_FILTERATION_OFFER_ALLD: "Offer : All",
  TOP_AGENT_FILTERATION_PROFIT_ALLD: "Profit : All",
  // USER - DETAIL 
  USER_DETAIL_USERS: "Users",
  USER_DETAIL_VIEW_CUSTOMER: "View Customer",
  USER_DETAIL_CUSTOMER_SINCE: " Customer Since",
  USER_DETAIL_EDIT_CUSTOMER: "Edit Customer",
  USER_DETAIL_SUSPEND_CUSTOMER: "Suspend Customer",
  USER_DETAIL_USER_ID: " User ID",
  USER_DETAIL_ACTIVE_BTN_STATUS: " Active",
  USER_DETAIL_INACTIVE_BTN_STATUS: " In-Active",
  USER_DETAIL_PHONE_NUM: " Phone",
  USER_DETAIL_EMAIL_ID: " Email",
  USER_DETAIL_ALL_ORDER: " All Order ",
  USER_DETAIL_PENDING: " Pending ",
  USER_DETAIL_COMPLETED: " Completed ",
  USER_DETAIL_CANCELED: "Canceled",
  USER_DETAIL_RETUNRED: "Returned",
  USER_DETAIL_DAMAGED: "Damaged",
  USER_DETAILS_HOME_ADDRESS: "Home Address",
  USER_DETAILS_BILLING_ADDRESS: "Billing Address",
  USER_DETAIL_TABEL_HEADER: "Janet's Order",
  USER_DETAIL_TABEL_FILTER: "Filter",
  USER_DETAIL_TABEL_FILTER2: "Filter",
  USER_DETAIL_TABEL_SHARE: "Share",
  USER_DETAIL_TABEL_TITLE: "Janet's Orders",
  USER_DETAIL_TABEL_HEADER_ORDER_DATE: "Order Date",
  USER_DETAIL_TABEL_HEADER_ORDER_TYPE: "Order Type",
  USER_DETAIL_TABEL_HEADER_TRACKING_ID: "Tracking ID",
  USER_DETAIL_TABEL_HEADER_ORDER_TOTAL: "Order Total ",
  USER_DETAIL_TABEL_HEADER_ACTION: "Action",
  // support 
  TICKET_TABLE_HEADER_NAME:" TICKET ID",
  TICKET_TABLE_HEADER_DATE:"DATE & TIME",
  TICKET_TABLE_HEADER_MSG:"MESSAGE",
  TICKET_TABLE_HEADER_RESOLVED:"RESOLVE",
  TICKET_TABLE_HEADER_RESOLVE_AT:"UPDATE AT",
  TICKET_TABLE_HEADER_STATUS:"STATUS",
  // profile 
  PROFILE_CHANEG_PASSWORD:"Change password ",
  PROFILE_FIELD_PASSWORD:'Password',
  PROFILE_FIELD_PASSWORD_CONFIRM:'Confirm Password',

  PROFILE_USER:'Name',
  PROFILE_USER_EMAIL:'Email',
  PROFILE_USER_ROLE:'Role',
  PROFILE_USER_LOGOUT:'logout'

}